<template>
  <v-stepper v-model="e1">
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="w-100" elevation="0">
          <v-card-text>
            <v-card-title>بنر مد نظر خود را آپلود کنید</v-card-title>
          </v-card-text>
          <v-card-item>
            <v-file-input
              label="آپلود بنر "
              outlined
              accept="image/*"
              v-model="bannerSelect.banner"
              prepend-icon="mdi-camera"
              @change="handleFile"
            ></v-file-input>
          </v-card-item>
          <v-card-item>
            <v-textarea
              v-model="bannerSelect.discription"
              outlined
              append-icon="mdi-text-box-edit"
              label="توضیحات"
            >
            </v-textarea>
          </v-card-item>
        </v-card>
        <div class="w-100 d-flex justify-content-end">
          <v-btn color="primary" @click="nextBtn">
            ادامه
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-content class="pa-2" step="2">
        <div class="pa-2">
          <v-card
            elevation="2"
            rounded="xl"
            height="60px"
            class="pa-2 w-100 border b d-flex align-items-center"
          >
            <v-avatar>
              <v-img aspect-ratio="1" :src="showImage"></v-img>
            </v-avatar>
            <v-card-text>
              <v-card-title>رزرو اجاره بنر</v-card-title>
              <v-card-subtitle
                >{{ bannerSelect.reserveDay }} روزه با مبلغ:
                {{
                  (bannerSelect.reserveDay * bannerSelect.day).toLocaleString()
                }}</v-card-subtitle
              >
            </v-card-text>
          </v-card>
        </div>
        <v-card elevation="0" class="pa-2">
          <v-card-title>
            جهت پرداخت رزرو بنر تبلیغاتی یکی از درگاه های زیر را انتخاب کنید
          </v-card-title>
          <v-card-item>
            <select-gate-slaes v-model="gateModel" />
          </v-card-item>
        </v-card>
        <div class="w-100 d-flex justify-content-between">
          <v-btn outlined color="red" @click="e1 = 1">
            <v-icon>mdi-chevron-right</v-icon>
            بازگشت
          </v-btn>
          <v-btn
            :disabled="Object.keys(gateModel).length == 0"
            color="green"
            class="mx-2"
            outlined
          >
            پرداخت
            <v-icon>mdi-credit-card-multiple</v-icon>
          </v-btn>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import selectGateSlaes from "./gate/selectGateSlaes.vue";
export default {
  components: { selectGateSlaes },
  name: "reserveBanner",
  props: { value: Object },
  data() {
    return {
      e1: 1,
      gateModel: {},
      showImage: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Object.keys(val) == 0) {
          this.gateModel = {};
          this.showImage = null;
          this.e1 = 1;
        }
      },
    },
  },
  computed: {
    bannerSelect: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    nextBtn() {
      if (this.bannerSelect.banner && this.bannerSelect.banner.size > 0) {
        this.e1 = 2;
      } else {
        this.$toast.error("مقدار فایل نمیتواند خالی باشد");
      }
    },
    handleFile(file) {
      const selectedFile = Array.isArray(file) ? file[0] : file;
      if (selectedFile && selectedFile.type.startsWith("image/")) {
        this.showImage = URL.createObjectURL(selectedFile);
      } else {
        this.showImage = null;
        this.$toast.error("لطفا فقط عکس وارد کنید");
      }
    },
  },
};
</script>

<style></style>
